///<reference path="../common/smart-mover.models.ts"/>
///<reference path="../common/data-template-base.ts"/>
///<reference path="../filter-templates/active-inactive.filter.ts"/>
///<reference path="../../../common/security.keys.ts"/>
///<reference path="../collections/report-taxes.collection.ts"/>
///<reference path="../../../../plugins/reports/reports.models.ts"/>


module Meevo.Components.Controls.SmartMover {

    import Dictionary = _.Dictionary;
    import ModalTranslationModes = Meevo.Components.Modal.ModalTranslationModes;

    export class ReportTaxesDataTemplate extends DataTemplateBase implements IDataTemplate {

        protected taxesCollection: ReportTaxesCollection;
        protected maxTaxesLimitation: ILimitationsBase;

        public allSelectedLabel: string;
        public title: string;
        public showDescription: boolean;
        public description: string;

        get collection() {
            return this.taxesCollection;
        }

        get totalSelectedMessage() {
            return this._totalSelectedMessage;
        }

        set totalSelectedMessage(message: string) {
            this._totalSelectedMessage = message;

            this.totalSelectedMessageModel = new TotalSelectedReportTaxesText(message, this.taxesCollection);
        }

        constructor(model: Dictionary<any>, properties: string[], {criteria, modalService, $scope, $filter, required}: IDataTemplateOptions) {
            super(model, properties, criteria);

            this.taxesCollection = new ReportTaxesCollection(this.model[properties[0]], [], {
                criteria,
                idKey: 'taxType_LId',
                $filter
            });
            this.maxTaxesLimitation = new ReportTaxesLimitations(this.taxesCollection, $scope, (lastChangedModelId: ModelValueType) => {
                this.taxesCollection.get(lastChangedModelId).selected = false;

                modalService.alert('LABEL_MAX_SELECTED_TAX_REACHED', ModalTranslationModes.Translate);
            });

            this.showMover = false;
            this.title = 'LABEL_TAXES';
            this.allSelectedLabel = 'LABEL_ALL_ACTIVE_TAXES';
            this.totalSelectedMessage = 'LABEL_TOTAL_TAXES_SELECTED';
            this.showDescription = false;
            this.description = 'LABEL_TAX_MOVER_LABEL';

            this.on(ON_FETCH_END, () => {
                if (this.taxesCollection.models.length > MAX_SELECTED_TAXES) {
                    this.showMover = true;
                    this.showDescription = true;
                }
            });

            if (required) {
                this.validation.push(
                    new RequiredValidation(this.collection, 'LABEL_TAX_TYPE_REQUIRED')
                );
            }
        }

        onHideToggle(hidden: boolean): void {
            super.onHideToggle(hidden);

            if (!hidden) {
                /**
                 * if NOT selected
                 *   default: active taxes selected
                 * MAX 5 TAXES WILL BE ABLE TO BE SELECTED AT A TIME
                 */
                for (const model of this.taxesCollection.models) {
                    if (model.isActive) {
                        model.selected = true;
                    }
                }
            }
        }
    }
}
